var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:['previous-button', { first: _vm.first }],attrs:{"to":_vm.route}},[_vm._v(" PREVIOUS ")])}
var staticRenderFns = []

export { render, staticRenderFns }